<template>
  <Popup
    v-model="getNocardShow"
    class="getnocard"
    :close-on-click-overlay="false"
  >
    <aside></aside>
    <p><img src="./img/smail.png" alt="" /> 好运可能下次出现</p>
    <button class="close" @click="close">再摇一次</button>
  </Popup>
</template>
<script>
import { Popup } from 'vant'
export default {
  components: {
    Popup
  },
  props: {
    getNocardShow: {
      type: Boolean
    }
  },
  data () {
    return {
      ruleShow: true
    }
  },
  methods: {
    close () {
      this.$emit('getNocardClose')
    }
  }
}
</script>
<style lang='less' scoped>
.getnocard {
  background: #fffcf9;
  width: 6rem;
  border-radius: 0.2rem;
  padding-bottom: 0.45rem;
  .close {
    width: 4.2rem;
    line-height: 0.7rem;
    height: 0.7rem;
    background: #ff6633;
    border-radius: 0.35rem;
    text-align: center;
    display: block;
    font-size: @fz28;
    color: #fff;
    margin: 0 auto;
  }
  p {
    font-size: @fz32;
    color: #404040;
    text-align: center;
    padding: 0.6rem 0.3rem;
    img {
      width: 0.65rem;
      margin-right: 0.1rem;
    }
    .flex-center;
  }
  aside {
    width: 100%;
    height: 1.74rem;
    background: url(./img/thanks.png) no-repeat;
    background-size: 100% auto;
  }
}
</style>
